<template>
    <footer>
        <div
            class="w-full flex flex-col sm:flex-row items-center justify-center py-2 sm:py-0 sm:h-16 space-y-0 sm:space-y-0 sm:space-x-4"
        >
            <span class="text-xs text-gray-800 dark:text-slate-100 font-base">
                My10x Version
                <span v-if="version" v-cloak>{{ version }}</span>
            </span>
            <div class="sm:h-4 w-px bg-slate-500/20"></div>
            <Link
                href="/changelog"
                class="text-xs text-gray-800 hover:text-gray-400 dark:text-slate-100 dark:hover:text-slate-400 font-semibold"
            >
                Changelog
            </Link>
            <div class="sm:h-4 w-px bg-slate-500/20"></div>
            <Link
                href="/privacy-policy"
                target="_blank"
                class="text-xs text-gray-800 hover:text-gray-400 dark:text-slate-100 dark:hover:text-slate-400 font-semibold"
            >
                Privacy Policy
            </Link>
            <div class="sm:h-4 w-px bg-slate-500/20"></div>
            <Link
                href="/security"
                class="text-xs text-gray-800 hover:text-gray-400 dark:text-slate-100 dark:hover:text-slate-400 font-semibold"
            >
                Security
            </Link>
        </div>
    </footer>
</template>
<script setup>
import { Link, Head, usePage } from '@inertiajs/vue3';

const version = usePage().props.version;
</script>
